// extracted by mini-css-extract-plugin
export default {"container":"ActiveTradePlanModule_container__r2oyJ"};